import icon_search_blue from 'imgs/icons/windows/icon_search_blue.svg';
import icon_search_blue_hover from 'imgs/icons/windows/icon_search_blue_hover.svg';
import icon_view_list from 'imgs/icons/windows/icon_view_list.svg';
import icon_view_list_hover from 'imgs/icons/windows/icon_view_list_hover.svg';
import icon_view_list_on from 'imgs/icons/windows/icon_view_list_on.svg';
import icon_view_comp from 'imgs/icons/windows/icon_view_comp.svg';
import icon_view_comp_hover from 'imgs/icons/windows/icon_view_comp_hover.svg';
import icon_view_comp_on from 'imgs/icons/windows/icon_view_comp_on.svg';
import icon_view_map from 'imgs/icons/windows/icon_view_map.svg';
import icon_view_map_hover from 'imgs/icons/windows/icon_view_map_hover.svg';
import icon_view_map_on from 'imgs/icons/windows/icon_view_map_on.svg';
import icon_moreinfo from 'imgs/icons/windows/icon_moreinfo.svg';
import icon_moreinfo_hover from 'imgs/icons/windows/icon_moreinfo_hover.svg';
import icon_moreinfo_exp from 'imgs/icons/windows/icon_moreinfo_exp.svg';
import icon_moreinfo_exp_hover from 'imgs/icons/windows/icon_moreinfo_exp_hover.svg';
import icon_table_sort from 'imgs/icons/windows/icon_table_sort.svg';
import icon_table_sort_hover from 'imgs/icons/windows/icon_table_sort_hover.svg';
import icon_toggle_name from 'imgs/icons/windows/icon_toggle_name.svg';
import icon_toggle_name_hover from 'imgs/icons/windows/icon_toggle_name_hover.svg';
import icon_toggle_id from 'imgs/icons/windows/icon_toggle_id.svg';
import icon_toggle_id_hover from 'imgs/icons/windows/icon_toggle_id_hover.svg';
import icon_close_x from 'imgs/icons/windows/icon_close_x.svg';
import icon_close_x_hover from 'imgs/icons/windows/icon_close_x_hover.svg';
import icon_customdate from 'imgs/icons/windows/icon_customdate.svg';
import icon_add from 'imgs/icons/windows/icon_add.svg';
import icon_add_hover from 'imgs/icons/windows/icon_add_hover.svg';
import icon_export from 'imgs/icons/windows/icon_export.svg';
import icon_export_hover from 'imgs/icons/windows/icon_export_hover.svg';
import icon_spinner_small from 'imgs/icons/windows/icon_spinner_small.svg';
import icon_more_H from 'imgs/icons/windows/icon_more_H.svg';
import icon_more_H_hover from 'imgs/icons/windows/icon_more_H_hover.svg';
import icon_edit from 'imgs/icons/windows/icon_edit.svg';
import icon_edit_hover from 'imgs/icons/windows/icon_edit_hover.svg';
import icon_checkbox_checked from 'imgs/icons/windows/icon_checkbox_checked.svg';
import icon_checkbox_unchecked from 'imgs/icons/windows/icon_checkbox_unchecked.svg';
import icon_checkbox_checked_hover from 'imgs/icons/windows/icon_checkbox_hover.svg';
import icon_clear_flter_x from 'imgs/icons/windows/icon_clear_flter_x.svg';
import icon_clear_flter_x_hover from 'imgs/icons/windows/icon_clear_flter_x_hover.svg';
import icon_more_note from 'imgs/icons/windows/icon_more_note.svg';
import icon_more_note_hover from 'imgs/icons/windows/icon_more_note_hover.svg';
import icon_device_more from 'imgs/icons/windows/icon_device_more.svg';
import icon_device_more_hover from 'imgs/icons/windows/icon_device_more_hover.svg';
import icon_device_note from 'imgs/icons/windows/icon_device_note.svg';
import icon_device_note_hover from 'imgs/icons/windows/icon_device_note_hover.svg';
import icon_device_close from 'imgs/icons/windows/icon_device_close.svg';
import icon_device_close_hover from 'imgs/icons/windows/icon_device_close_hover.svg';
import icon_help_xs from 'imgs/icons/windows/icon_help_xs.svg';
import icon_help_xs_hover from 'imgs/icons/windows/icon_help_xs_hover.svg';
import icon_action from 'imgs/icons/windows/icon_action.svg';
import icon_action_hover from 'imgs/icons/windows/icon_action_hover.svg';
import icon_select_all from 'imgs/icons/windows/icon_select_all.svg';
import icon_select_all_hover from 'imgs/icons/windows/icon_select_all_hover.svg';
import icon_select_none from 'imgs/icons/windows/icon_select_none.svg';
import icon_select_none_hover from 'imgs/icons/windows/icon_select_none_hover.svg';
import icon_select_poli from 'imgs/icons/windows/icon_select_poli.svg';
import icon_select_poli_hover from 'imgs/icons/windows/icon_select_poli_hover.svg';
import icon_select_circle from 'imgs/icons/windows/icon_select_circle.svg';
import icon_select_circle_hover from 'imgs/icons/windows/icon_select_circle_hover.svg';
import icon_select_rec from 'imgs/icons/windows/icon_select_rec.svg';
import icon_select_rec_hover from 'imgs/icons/windows/icon_select_rec_hover.svg';
import icon_zoomin from 'imgs/icons/windows/icon_zoomin.svg';
import icon_zoomin_hover from 'imgs/icons/windows/icon_zoomin_hover.svg';
import icon_zoomout from 'imgs/icons/windows/icon_zoomout.svg';
import icon_zoomout_hover from 'imgs/icons/windows/icon_zoomout_hover.svg';
import icon_zoom_in from 'imgs/icons/windows/icon_zoom_in.svg';
import icon_zoom_in_hover from 'imgs/icons/windows/icon_zoom_in_hover.svg';
import icon_zoom_out from 'imgs/icons/windows/icon_zoom_out.svg';
import icon_zoom_out_hover from 'imgs/icons/windows/icon_zoom_out_hover.svg';
import icon_donor from 'imgs/icons/windows/icon_donor.svg';
import icon_service from 'imgs/icons/windows/icon_service.svg';
import icon_reboot_success from 'imgs/icons/windows/icon_success_medium.svg';
import icon_close_circle from 'imgs/icons/windows/icon_close_circle.svg';
import icon_close_circle_hover from 'imgs/icons/windows/icon_close_circle_hover.svg';
import icon_unlocked from 'imgs/icons/windows/icon_unlocked.svg';
import icon_unlocked_disabled from 'imgs/icons/windows/icon_unlocked_disabled.svg';
import icon_locked from 'imgs/icons/windows/icon_locked.svg';
import icon_locked_disabled from 'imgs/icons/windows/icon_locked_disabled.svg';
import icon_unlocking from 'imgs/icons/windows/icon_unlocking.svg';
import icon_locking from 'imgs/icons/windows/icon_locking.svg';
import icon_wifi_disabled from 'imgs/icons/windows/icon_wifi_disabled.svg';
import icon_wifi_disabling from 'imgs/icons/windows/icon_wifi_disabling.svg';
import icon_wifi_enabled from 'imgs/icons/windows/icon_wifi_enabled.svg';
import icon_wifi_enabling from 'imgs/icons/windows/icon_wifi_enabling.svg';
import icon_close_mid from 'imgs/icons/windows/icon_close_mid.svg';
import icon_close_mid_hover from 'imgs/icons/windows/icon_close_mid_hover.svg';
import icon_error_mid from 'imgs/icons/windows/icon_error_mid.svg';
import icon_wifi_showAPN from 'imgs/icons/windows/icon_wifi_showAPN.svg';
import icon_wifi_showAPN_hover from 'imgs/icons/windows/icon_wifi_showAPN_hover.svg';
import icon_add_time from 'imgs/icons/windows/icon_add_time.svg';
import icon_add_time_hover from 'imgs/icons/windows/icon_add_time_hover.svg';
import icon_subtract_time from 'imgs/icons/windows/icon_subtract_time.svg';
import icon_sandclock from 'imgs/icons/windows/icon_sandclock.svg';
import icon_subtract_time_hover from 'imgs/icons/windows/icon_subtract_time_hover.svg';
import icon_failed_medium from 'imgs/icons/windows/icon_failed_medium.svg';
import icon_commit_edit from 'imgs/icons/windows/icon_commit_edit.svg';
import icon_cancel_edit from 'imgs/icons/windows/icon_cancel_edit.svg';
import icon_commit_disabled from 'imgs/icons/windows/icon_commit_disabled.svg';
import icon_edit_name from 'imgs/icons/windows/icon_edit_name.svg';
import icon_edit_name_hover from 'imgs/icons/windows/icon_edit_name_hover.svg';
import icon_collapse_row from 'imgs/icons/windows/icon_collapse_row.svg';
import icon_collapse_row_hover from 'imgs/icons/windows/icon_collapse_row_hover.svg';
import icon_x from 'imgs/icons/windows/icon_small_close.svg';
import icon_x_hover from 'imgs/icons/windows/icon_small_close_hover.svg';
import icon_scheduling from 'imgs/icons/windows/icon_scheduling.svg';
import icon_success from 'imgs/icons/windows/icon_success.svg';
import icon_error from 'imgs/icons/windows/icon_error.svg';
import icon_init from 'imgs/icons/windows/icon_initializing.svg';
import icon_rebooting from 'imgs/icons/windows/icon_rebooting.svg';
import icon_note from 'imgs/icons/windows/icon_note.svg';
import icon_note_hover from 'imgs/icons/windows/icon_note_hover.svg';
import icon_dropdown_arrow from 'imgs/icons/windows/icon_dropdown_arrow.svg';
import icon_dropdown_arrow_hover from 'imgs/icons/windows/icon_dropdown_arrow_hover.svg';
import icon_logo_IBMS_compact_fixed from 'imgs/logos/logo_IBMS_compact_fixed.svg';
import icon_IBMS_wide from 'imgs/logos/IBMS_wide.svg';
import icon_devices from 'imgs/icons/nav_bar/icon_devices.svg';
import icon_devices_hover from 'imgs/icons/nav_bar/icon_devices_hover.svg';
import icon_actions from 'imgs/icons/nav_bar/icon_actions.svg';
import icon_actions_hover from 'imgs/icons/nav_bar/icon_actions_hover.svg';
import icon_admin from 'imgs/icons/nav_bar/icon_admin.svg';
import icon_admin_hover from 'imgs/icons/nav_bar/icon_admin_hover.svg';
import icon_user from 'imgs/icons/nav_bar/icon_user.svg';
import icon_user_hover from 'imgs/icons/nav_bar/icon_user_hover.svg';
import icon_expand from 'imgs/icons/nav_bar/icon_expand.svg';
import icon_expand_hover from 'imgs/icons/nav_bar/icon_expand_hover.svg';
import icon_rastering from 'imgs/icons/windows/icon_rastering.svg';
import icon_close_errorbox from 'imgs/icons/windows/icon_close_errorbox.svg';
import icon_close_errorbox_hover from 'imgs/icons/windows/icon_close_errorbox_hover.svg';
import icon_raster_success from 'imgs/icons/windows/icon_raster_success.svg';
import icon_search from 'imgs/icons/windows/icon_search.svg';
import icon_error_s from 'imgs/icons/windows/icon_error_s.svg';
import icon_schedule_bttn from 'imgs/icons/windows/icon_schedule_bttn.svg';
import icon_schedule_bttn_hover from 'imgs/icons/windows/icon_schedule_bttn_hover.svg';
import icon_revert from 'imgs/icons/windows/icon_revert.svg';
import icon_revert_hover from 'imgs/icons/windows/icon_revert_hover.svg';
import icon_slider_bg from 'imgs/icons/windows/icon_slider_bg.svg';
import icon_check_green from 'imgs/icons/windows/icon_check_green.svg';
import icon_uploadnewversion from 'imgs/icons/windows/icon_uploadnewversion.svg';
import icon_delete from 'imgs/icons/windows/icon_delete.svg';
import icon_delete_hover from 'imgs/icons/windows/icon_delete_hover.svg';
import icon_logo from 'imgs/icons/windows/pivotal-black.svg';
import icon_ibms_wide_white from 'imgs/logos/IBMS_wide_White.svg';
import icon_login_mail from 'imgs/icons/windows/icon_login_mail.svg';
import icon_login_mail_on from 'imgs/icons/windows/icon_login__mail_on.svg';
import icon_login_mail_error from 'imgs/icons/windows/icon_login_mail_error.svg';
import icon_login_password from 'imgs/icons/windows/icon_login_password.svg';
import icon_login_password_on from 'imgs/icons/windows/icon_login_password_on.svg';
import icon_login_password_error from 'imgs/icons/windows/icon_login_password_error.svg';
import icon_info from 'imgs/icons/windows/icon_info.svg';
import icon_info_hover from 'imgs/icons/windows/icon_info_hover.svg';
import icon_info_small from 'imgs/icons/windows/icon_info_small.svg';
import icon_info_small_hover from 'imgs/icons/windows/icon_info_small_hover.svg';
import icons_arrow_goback from 'imgs/icons/windows/icons_arrow_goback.svg';
import icons_arrow_goback_hover from 'imgs/icons/windows/icons_arrow_goback_hover.svg';
import icon_alarm_undefined from 'imgs/icons/windows/icon_alarm_undefined.svg';
import icon_alarm_critical from 'imgs/icons/windows/icon_alarm_critical.svg';
import icon_alarm_major from 'imgs/icons/windows/icon_alarm_major.svg';
import icon_alarm_minor from 'imgs/icons/windows/icon_alarm_minor.svg';
import icon_alarm_warning from 'imgs/icons/windows/icon_alarm_warning.svg';
import icon_alarm_info from 'imgs/icons/windows/icon_alarm_info.svg';
import icon_commission from 'imgs/icons/windows/icon_commission.svg';
import icon_commission_hover from 'imgs/icons/windows/icon_commission_hover.svg';
import icon_commission_disabled from 'imgs/icons/windows/icon_commission_disabled.svg';
import icon_vertical_expand from 'imgs/icons/windows/icon_vertical_expand.svg';
import icon_vertical_expand_hover from 'imgs/icons/windows/icon_vertical_expand_hover.svg';
import icon_browser_chrome from 'imgs/icons/windows/icon_browser_chrome.svg';
import icon_browser_firefox from 'imgs/icons/windows/icon_browser_firefox.svg';
import icon_browser_edge from 'imgs/icons/windows/icon_browser_edge.svg';
import icon_view_alarm from 'imgs/icons/windows/icon_view_alarm.svg';
import icon_view_alarm_hover from 'imgs/icons/windows/icon_view_alarm_hover.svg';
import icon_alarm_noalarm from 'imgs/icons/windows/icon_alarm_noalarm.svg';
import icon_field_enter from 'imgs/icons/windows/icon_field_enter.svg';
import icon_field_enter_hover from 'imgs/icons/windows/icon_field_enter_hover.svg';
import icon_entered_success from 'imgs/icons/windows/icon_entered_success.svg';
import icon_entered_failed from 'imgs/icons/windows/icon_entered_failed.svg';
import icon_pivot_large from 'imgs/icons/windows/icon_pivot_large.svg';
import icon_LED_turning from 'imgs/icons/windows/icon_LED_turning.svg';
import icon_error_white from 'imgs/icons/windows/icon_error_white.svg';
import icon_success_SWdownload from 'imgs/icons/windows/icon_success_SWdownload.svg';
import icon_log from 'imgs/icons/windows/icon_log.svg';
import icon_log_hover from 'imgs/icons/windows/icon_log_hover.svg';
import icon_historical_log from 'imgs/icons/windows/icon_historical_log.svg';
import icon_historical_log_hover from 'imgs/icons/windows/icon_historical_log_hover.svg';
import icon_log_pause from 'imgs/icons/windows/icon_log_pause.svg';
import icon_log_start from 'imgs/icons/windows/icon_log_start.svg';
import icon_log_expand_rows from 'imgs/icons/windows/icon_log_expand_rows.svg';
import icon_log_expand_rows_hover from 'imgs/icons/windows/icon_log_expand_rows_hover.svg';
import icon_log_expand_cell from 'imgs/icons/windows/icon_log_expand_cell.svg';
import icon_log_expand_cell_hover from 'imgs/icons/windows/icon_log_expand_cell_hover.svg';
import icon_config_table from 'imgs/icons/windows/icon_config_table.svg';
import icon_config_table_hover from 'imgs/icons/windows/icon_config_table_hover.svg';
import icon_config_table_on from 'imgs/icons/windows/icon_config_table_on.svg';
import icon_config_table_charts from 'imgs/icons/windows/icon_config_table_charts.svg';
import icon_config_table_charts_hover from 'imgs/icons/windows/icon_config_table_charts_hover.svg';
import icon_config_table_charts_on from 'imgs/icons/windows/icon_config_table_charts_on.svg';
import icon_config_charts from 'imgs/icons/windows/icon_config_charts.svg';
import icon_config_charts_hover from 'imgs/icons/windows/icon_config_charts_hover.svg';
import icon_config_charts_on from 'imgs/icons/windows/icon_config_charts_on.svg';
import icon_arrow_open_options from 'imgs/icons/windows/icon_arrow_open_options.svg';
import icon_arrow_open_options_hover from 'imgs/icons/windows/icon_arrow_open_options_hover.svg';
import icon_arrow_closed_options from 'imgs/icons/windows/icon_arrow_closed_options.svg';
import icon_arrow_closed_options_hover from 'imgs/icons/windows/icon_arrow_closed_options_hover.svg';
import icon_log_export from 'imgs/icons/windows/icon_log_export.svg';
import icon_log_export_hover from 'imgs/icons/windows/icon_log_export_hover.svg';
import icon_calendar from 'imgs/icons/windows/icon_calendar.svg';
import icon_roles_add from 'imgs/icons/windows/icon_roles_add.svg';
import icon_roles_add_hover from 'imgs/icons/windows/icon_roles_add_hover.svg';
import icon_three_more from 'imgs/icons/windows/icon_three_more.svg';
import icon_three_more_hover from 'imgs/icons/windows/icon_three_more_hover.svg';
import icon_userpage_edit from 'imgs/icons/windows/icon_userpage_edit.svg';
import icon_userpage_edit_hover from 'imgs/icons/windows/icon_userpage_edit_hover.svg';
import icon_role_none_selected from 'imgs/icons/windows/icon_role_none_selected.svg';
import icon_role_selected from 'imgs/icons/windows/icon_role_selected.svg';
import icon_role_select_hover from 'imgs/icons/windows/icon_role_select_hover.svg';
import icon_edit_detail from 'imgs/icons/windows/icon_edit_detail.svg';
import icon_edit_detail_hover from 'imgs/icons/windows/icon_edit_detail_hover.svg';
import icon_collapseunits from 'imgs/icons/windows/icon_collapseunits.svg';
import icon_collapseunits_hover from 'imgs/icons/windows/icon_collapseunits_hover.svg';
import icon_expandunits from 'imgs/icons/windows/icon_expandunits.svg';
import icon_expandunits_hover from 'imgs/icons/windows/icon_expandunits_hover.svg';
import icon_threeV from 'imgs/icons/windows/icon_threeV.svg';
import icon_threeV_hover from 'imgs/icons/windows/icon_threeV_hover.svg';
import icon_med_close from 'imgs/icons/windows/icon_med_close.svg';
import icon_med_close_hover from 'imgs/icons/windows/icon_med_close_hover.svg';
import icon_alarm_critical_num from 'imgs/icons/windows/icon_alarm_critical_num.svg';
import icon_alarm_warning_num from 'imgs/icons/windows/icon_alarm_warning_num.svg';
import icon_alarm_major_num from 'imgs/icons/windows/icon_alarm_major_num.svg';
import icon_alarm_info_num from 'imgs/icons/windows/icon_alarm_info_num.svg';
import icon_alarm_minor_num from 'imgs/icons/windows/icon_alarm_minor_num.svg';
import icon_alarm_unknown_num from 'imgs/icons/windows/icon_alarm_unknown_num.svg';
import icon_alarm_major_minor_none from 'imgs/icons/windows/icon_alarm_major_minor_none.svg';
import icon_alarm_unknown_none from 'imgs/icons/windows/icon_alarm_unknown_none.svg';
import icon_alarm_critical_none from 'imgs/icons/windows/icon_alarm_critical_none.svg';
import icon_alarm_warning_info_none from 'imgs/icons/windows/icon_alarm_warning_info_none.svg';
import icon_highlight from 'imgs/icons/windows/icon_highlight.svg';
import icon_highlight_hover from 'imgs/icons/windows/icon_highlight_hover.svg';
import icon_not_commissioned_off from 'imgs/icons/windows/icon_not_commissioned_off.svg';
import icon_commissioned from 'imgs/icons/windows/icon_commissioned.svg';
import icon_commissioned_gray from 'imgs/icons/windows/icon_commissioned_gray.svg';
import icon_not_commissioned from 'imgs/icons/windows/icon_not_commissioned.svg';
import icon_offline_off from 'imgs/icons/windows/icon_offline_off.svg';
import icon_offline from 'imgs/icons/windows/icon_offline.svg';
import icon_connected from 'imgs/icons/windows/icon_connected.svg';
import icon_locked_off from 'imgs/icons/windows/icon_locked_off.svg';
import icon_locked_device from 'imgs/icons/windows/icon_locked_device.svg';
import icon_locked_device_off from 'imgs/icons/windows/icon_locked_device_off.svg';
import icon_handle from 'imgs/icons/windows/icon_handle.svg';
import icon_handle_hover_drag from 'imgs/icons/windows/icon_handle_hover_drag.svg';
import icon_close_window_mid from 'imgs/icons/windows/icon_close_window_mid.svg';
import icon_close_window_mid_hover from 'imgs/icons/windows/icon_close_window_mid_hover.svg';
import icon_echo from 'imgs/icons/windows/icon_echo.svg';
import icon_pivot from 'imgs/icons/windows/icon_pivot.svg';
import icon_main_grid from 'imgs/icons/windows/icon_main_grid.svg';
import icon_main_grid_hover from 'imgs/icons/windows/icon_main_grid_hover.svg';
import icon_main_grid_on from 'imgs/icons/windows/icon_main_grid_on.svg';
import icon_main_split from 'imgs/icons/windows/icon_main_split.svg';
import icon_main_split_hover from 'imgs/icons/windows/icon_main_split_hover.svg';
import icon_main_split_on from 'imgs/icons/windows/icon_main_split_on.svg';
import icon_main_table from 'imgs/icons/windows/icon_main_table.svg';
import icon_main_table_hover from 'imgs/icons/windows/icon_main_table_hover.svg';
import icon_main_table_on from 'imgs/icons/windows/icon_main_table_on.svg';
import icon_sort from 'imgs/icons/windows/icon_sort.svg';
import icon_sort_hover from 'imgs/icons/windows/icon_sort_hover.svg';
import icon_warning from 'imgs/icons/windows/icon_warning.svg';
import icon_warning_2 from 'imgs/icons/windows/icon_warning_2.svg';
import icon_window_preferences from 'imgs/icons/windows/icon_window_preferences.svg';
import icon_window_preferences_hover from 'imgs/icons/windows/icon_window_preferences_hover.svg';
import icon_save_set from 'imgs/icons/windows/icon_save_set.svg';
import icon_add_devices from 'imgs/icons/windows/icon_add_devices.svg';
import icon_create_plus from 'imgs/icons/windows/icon_create_plus.svg';
import icon_actions_pill from 'imgs/icons/windows/icon_actions_pill.svg';
import icon_close_white from 'imgs/icons/windows/icon_close_white.svg';
import icon_close_white_hover from 'imgs/icons/windows/icon_close_white_hover.svg';
import icon_manage_set from 'imgs/icons/windows/icon_manage_set.svg';
import bttn_make_default from 'imgs/icons/windows/bttn_make_default.svg';
import bttn_make_default_hover from 'imgs/icons/windows/bttn_make_default_hover.svg';
import bttn_make_default_select from 'imgs/icons/windows/bttn_make_default_select.svg';
import icon_delete_list from 'imgs/icons/windows/icon_delete_list.svg';
import icon_delete_list_hover from 'imgs/icons/windows/icon_delete_list_hover.svg';
import icon_back_doc from 'imgs/icons/windows/icon_back_doc.svg';
import icon_back_doc_hover from 'imgs/icons/windows/icon_back_doc_hover.svg';
import bttn_update_filterset_hover from 'imgs/icons/windows/bttn_update_filterset_hover.svg';
import bttn_update_filterset_on from 'imgs/icons/windows/bttn_update_filterset_on.svg';
import bttn_update_filterset_off from 'imgs/icons/windows/bttn_update_filterset_off.svg';
import icons_cross_small from 'imgs/icons/windows/icons_cross_small.svg';
import icons_cross_small_hover from 'imgs/icons/windows/icons_cross_small_hover.svg';
import icon_add_16 from 'imgs/icons/windows/icon_add_16.svg';
import icon_add_16_hover from 'imgs/icons/windows/icon_add_16_hover.svg';
import icon_upload_18 from 'imgs/icons/windows/icon_upload_18.svg';
import icon_upload_18_hover from 'imgs/icons/windows/icon_upload_18_hover.svg';
import icon_warning_round from 'imgs/icons/windows/icon_warning_round.svg';
import left_arrow_default from 'imgs/icons/windows/left_arrow_default.svg';
import left_arrow_hover from 'imgs/icons/windows/left_arrow_hover.svg';
import icon_commission_success from 'imgs/icons/windows/icon_commission_success.svg';
import icon_beamrank_1 from 'imgs/icons/windows/icon_beamrank_1.svg';
import icon_beamrank_2 from 'imgs/icons/windows/icon_beamrank_2.svg';
import icon_beamrank_3 from 'imgs/icons/windows/icon_beamrank_3.svg';
import icon_beamrank_c from 'imgs/icons/windows/icon_beamrank_c.svg';
import icon_beamrank_1_selected from 'imgs/icons/windows/icon_beamrank_1_selected.svg';
import icon_beamrank_2_selected from 'imgs/icons/windows/icon_beamrank_2_selected.svg';
import icon_beamrank_3_selected from 'imgs/icons/windows/icon_beamrank_3_selected.svg';
import icon_beamrank_c_selected from 'imgs/icons/windows/icon_beamrank_c_selected.svg';
import icon_dropdown_arrow_24_default from 'imgs/icons/windows/icon_dropdown_arrow_24_default.svg';
import icon_dropdown_arrow_24_hover from 'imgs/icons/windows/icon_dropdown_arrow_24_hover.svg';
import icon_toggle_40_hover from 'imgs/icons/windows/icon_toggle_40_hover.svg';
import icon_toggle_40_off from 'imgs/icons/windows/icon_toggle_40_off.svg';
import icon_toggle_40_on from 'imgs/icons/windows/icon_toggle_40_on.svg';
import icon_setup_24_hover from 'imgs/icons/windows/icon_setup_24_hover.svg';
import icon_setup_24_default from 'imgs/icons/windows/icon_setup_24_default.svg';
import icon_confighistory from 'imgs/icons/windows/icon_confighistory.svg';
import icon_confighistory_hover from 'imgs/icons/windows/icon_confighistory_hover.svg';
import icon_retrieve_default from 'imgs/icons/windows/icon_retrieve_default.svg';
import icon_retrieve_hover from 'imgs/icons/windows/icon_retrieve_hover.svg';
import icon_retrieve_disabled from 'imgs/icons/windows/icon_retrieve_disabled.svg';
import icon_split_default from 'imgs/icons/windows/icon_split_default.svg';
import icon_split_hover from 'imgs/icons/windows/icon_split_hover.svg';
import icon_split_selected from 'imgs/icons/windows/icon_split_selected.svg';
import icon_all_mute from 'imgs/icons/windows/icon_all_mute.svg';
import icon_all from 'imgs/icons/windows/icon_all.svg';
import icon_none_mute from 'imgs/icons/windows/icon_none_mute.svg';
import icon_none from 'imgs/icons/windows/icon_none.svg';
import icon_partial_mute from 'imgs/icons/windows/icon_partial_mute.svg';
import icon_partial from 'imgs/icons/windows/icon_partial.svg';
import icon_bluecheckbox_checked from 'imgs/icons/windows/icon_bluecheckbox_checked.svg';
import icon_bluecheckbox_unchecked from 'imgs/icons/windows/icon_bluecheckbox_unchecked.svg';
import icon_bluecheckbox_hover from 'imgs/icons/windows/icon_bluecheckbox_hover.svg';
import icon_arrow from 'imgs/icons/nav_bar/icon_arrow.svg';
import icon_geofencing from 'imgs/icons/windows/icon_geofencing.svg';
import icon_gnb_on from 'imgs/icons/windows/icon_gnb_on.svg';
import icon_gnb_on_hover from 'imgs/icons/windows/icon_gnb_on_hover.svg';
import icon_gnb_off from 'imgs/icons/windows/icon_gnb_off.svg';
import icon_gnb_off_hover from 'imgs/icons/windows/icon_gnb_off_hover.svg';
import icon_polygon_creation from 'imgs/icons/windows/icon_polygon_creation.svg';
import icon_polygon_creation_hover from 'imgs/icons/windows/icon_polygon_creation_hover.svg';
import icon_rectangle_creation from 'imgs/icons/windows/icon_rectangle_creation.svg';
import icon_rectangle_creation_hover from 'imgs/icons/windows/icon_rectangle_creation_hover.svg';
import icon_dots_vertical from 'imgs/icons/nav_bar/icon_dots_vertical.svg';
import icon_map_expand from 'imgs/icons/nav_bar/icon_map_expand.svg';
import icon_map_expand_hover from 'imgs/icons/nav_bar/icon_map_expand_hover.svg';
import icon_map_shrink from 'imgs/icons/nav_bar/icon_map_shrink.svg';
import icon_map_shrink_hover from 'imgs/icons/nav_bar/icon_map_shrink_hover.svg';
import icon_search_small from 'imgs/icons/windows/icon_search_small.svg';
import icon_greycheckbox from 'imgs/icons/windows/icon_greycheckbox.svg';
import icon_triangle from 'imgs/icons/nav_bar/icon_triangle.svg';
import icon_checkbox_unchecked_disabled from 'imgs/icons/windows/icon_checkbox_unchecked_disabled.svg';
import icon_checkbox_checked_disabled from 'imgs/icons/windows/icon_checkbox_checked_disabled.svg';
import icon_import from 'imgs/icons/nav_bar/icon_import.svg';
import icon_import_hover from 'imgs/icons/nav_bar/icon_import_hover.svg';
import icon_action_check from 'imgs/icons/nav_bar/icon_action_check.svg';
import icon_arrows from 'imgs/icons/nav_bar/icon_arrows.svg';
import icon_arrows_hover from 'imgs/icons/nav_bar/icon_arrows_hover.svg';
import icon_diag_raster from 'imgs/icons/windows/icon_diag_raster.png';
import icon_diag_raster_hovered from 'imgs/icons/windows/icon_diag_raster_hovered.png';
import icon_diag_raster_disabled from 'imgs/icons/windows/icon_diag_raster_disabled.svg';
import icon_led_blink_on from 'imgs/icons/windows/icon_led_blink_on.svg';
import icon_monitor from 'imgs/icons/windows/icon_monitor.svg';
import icon_monitor_hover from 'imgs/icons/windows/icon_monitor_hover.svg';
import icon_monitor_selected from 'imgs/icons/windows/icon_monitor_selected.svg';
import icon_toggle_on from 'imgs/icons/windows/icon_toggle_on.svg';
import icon_toggle_on_hover from 'imgs/icons/windows/icon_toggle_on_hover.svg';
import icon_toggle_off from 'imgs/icons/windows/icon_toggle_off.svg';
import icon_toggle_off_hover from 'imgs/icons/windows/icon_toggle_off_hover.svg';
import icon_create_new from 'imgs/icons/windows/icon_create_new.svg';
import icon_create_new_hover from 'imgs/icons/windows/icon_create_new_hover.svg';
import icon_alert_show_less from 'imgs/icons/windows/icon_alert_show_less.svg';
import icon_alert_show_less_hover from 'imgs/icons/windows/icon_alert_show_less_hover.svg';
import icon_alert_show_more from 'imgs/icons/windows/icon_alert_show_more.svg';
import icon_alert_show_more_hover from 'imgs/icons/windows/icon_alert_show_more_hover.svg';
import icon_duplicate from 'imgs/icons/windows/icon_duplicate.svg';
import icon_duplicate_hover from 'imgs/icons/windows/icon_duplicate_hover.svg';
import icon_editing from 'imgs/icons/windows/icon_editing.svg';
import icon_editing_hover from 'imgs/icons/windows/icon_editing_hover.svg';
import icon_trash from 'imgs/icons/windows/icon_trash.svg';
import icon_trash_hover from 'imgs/icons/windows/icon_trash_hover.svg';
import icon_orange_checkbox_checked_disabled from 'imgs/icons/windows/icon_orange_checkbox_checked_disabled.svg';
import icon_orange_checkbox_not_checked_disabled from 'imgs/icons/windows/icon_orange_checkbox_not_checked_disabled.svg';
import icon_primary_checkbox_checked from 'imgs/icons/windows/icon_primary_checkbox_checked.svg';
import icon_primary_checkbox_not_checked from 'imgs/icons/windows/icon_primary_checkbox_not_checked.svg';
import icon_primary_checkbox_not_checked_hover from 'imgs/icons/windows/icon_primary_checkbox_not_checked_hover.svg';
import icon_multy_value_close from 'imgs/icons/windows/icon_multy_value_close.svg';
import icon_multy_value_close_hover from 'imgs/icons/windows/icon_multy_value_close_hover.svg';
import icon_reveal_devices from 'imgs/icons/nav_bar/icon_reveal_devices.svg';
import icon_reveal_devices_disabled from 'imgs/icons/nav_bar/icon_reveal_devices_disabled.svg';
import icon_reveal_devices_hover from 'imgs/icons/nav_bar/icon_reveal_devices_hover.svg';
import icon_hide_devices from 'imgs/icons/nav_bar/icon_hide_devices.svg';
import icon_hide_devices_hover from 'imgs/icons/nav_bar/icon_hide_devices_hover.svg';
import icon_hide_devices_disabled from 'imgs/icons/nav_bar/icon_hide_devices_disabled.svg';
import icon_polygons_pivots_search from 'imgs/icons/windows/icon_polygons_pivots_search.svg';
import icon_device_donor from 'imgs/icons/windows/icon_device_donor.svg';
import icon_device_service from 'imgs/icons/windows/icon_device_service.svg';
import icon_device_donor_small from 'imgs/icons/windows/icon_device_donor_small.svg';
import icon_device_donor_grey_small from 'imgs/icons/windows/icon_device_donor_grey_small.svg';
import icon_device_service_small from 'imgs/icons/windows/icon_device_service_small.svg';
import icon_device_service_grey_small from 'imgs/icons/windows/icon_device_service_grey_small.svg';
import icon_pivot_circle from 'imgs/icons/windows/icon_pivot_circle.svg';
import icon_polygon_circle from 'imgs/icons/windows/icon_polygon_circle.svg';
import icon_section_close from 'imgs/icons/nav_bar/icon_section_close.svg';
import icon_section_close_hover from 'imgs/icons/nav_bar/icon_section_close_hover.svg';
import icon_section_close_disabled from 'imgs/icons/nav_bar/icon_section_close_disabled.svg';
import icon_export_tool from 'imgs/icons/nav_bar/icon_export_tool.svg';
import icon_export_tool_hover from 'imgs/icons/nav_bar/icon_export_tool_hover.svg';
import icon_import_tool from 'imgs/icons/nav_bar/icon_import_tool.svg';
import icon_import_tool_hover from 'imgs/icons/nav_bar/icon_import_tool_hover.svg';
import icon_alerts_history from 'imgs/icons/nav_bar/icon_alerts_history.svg';
import icon_alerts_history_hover from 'imgs/icons/nav_bar/icon_alerts_history_hover.svg';
import icon_alerts_goback from 'imgs/icons/nav_bar/icon_alerts_goback.svg';
import icon_alerts_goback_hover from 'imgs/icons/nav_bar/icon_alerts_goback_hover.svg';
import icon_more_and_equal_operator from 'imgs/icons/windows/icon_more_and_equal_operator.svg';
import icon_more_operator from 'imgs/icons/windows/icon_more_operator.svg';
import icon_equal_operator from 'imgs/icons/windows/icon_equal_operator.svg';
import icon_not_equal_operator from 'imgs/icons/windows/icon_not_equal_operator.svg';
import icon_less_operator from 'imgs/icons/windows/icon_less_operator.svg';
import icon_less_or_equal_operator from 'imgs/icons/windows/icon_less_or_equal_operator.svg';
import led_status_gray from 'imgs/icons/windows/led_status_gray.svg';
import led_status_green from 'imgs/icons/windows/led_status_green.svg';
import led_status_red from 'imgs/icons/windows/led_status_red.svg';
import red_spinner from 'imgs/icons/windows/red_spinner.svg';
import blue_spinner from 'imgs/icons/windows/blue_spinner.svg';
import led_gray from 'imgs/icons/windows/led_gray.svg';
import led_green from 'imgs/icons/windows/led_green.svg';
import red_lock from 'imgs/icons/windows/red_lock.svg';
import success_check from 'imgs/icons/windows/success_check.svg';
import warning_circle from 'imgs/icons/windows/warning_circle.svg';
import wifi_off from 'imgs/icons/windows/wifi_off.svg';
import wifi_on from 'imgs/icons/windows/wifi_on.svg';
import blue_unlocked from 'imgs/icons/windows/blue_unlocked.svg';
import warning_orange from 'imgs/icons/windows/warning_orange.svg';
import swapper from 'imgs/icons/windows/swapper.svg';
import swapper_hover from 'imgs/icons/windows/swapper_hover.svg';
import right_arrow from 'imgs/icons/windows/right_arrow.svg';
import icon_black_right_arrow from 'imgs/icons/windows/icon_black_right_arrow.svg';
import icon_drag_dots_default from 'imgs/icons/windows/icon_drag_dots_default.svg';
import icon_drag_dots_hover from 'imgs/icons/windows/icon_drag_dots_hover.svg';
import locked_hover from 'imgs/icons/windows/locked_hover.svg';
import locked_default from 'imgs/icons/windows/locked_default.svg';
import unlocked_hover from 'imgs/icons/windows/unlocked_hover.svg';
import unlocked_default from 'imgs/icons/windows/unlocked_default.svg';
import locked_reversed from 'imgs/icons/windows/locked_reversed.svg';
import icon_unlocked_default from 'imgs/icons/windows/unlock-green.svg';
import icon_locked_status from 'imgs/icons/windows/icon_locked_status.svg';
import icon_locked_status_hover from 'imgs/icons/windows/icon_locked_status_hover.svg';
import icon_unlocked_status from 'imgs/icons/windows/icon_unlocked_status.svg';
import icon_unlocked_status_hover from 'imgs/icons/windows/icon_unlocked_status_hover.svg';
import icon_wifi_on_status from 'imgs/icons/windows/icon_wifi_on_status.svg';
import icon_wifi_on_status_hover from 'imgs/icons/windows/icon_wifi_on_status_hover.svg';
import icon_wifi_off_status from 'imgs/icons/windows/icon_wifi_off_status.svg';
import icon_wifi_off_status_hover from 'imgs/icons/windows/icon_wifi_off_status_hover.svg';
import icon_pivot_header from 'imgs/icons/windows/icon_pivot_header.svg';
import icon_file_download from 'imgs/icons/windows/icon_file_download.svg';
import icon_file_download_hover from 'imgs/icons/windows/icon_file_download_hover.svg';
import icon_chartset_delete from 'imgs/icons/windows/icon_chartset_delete.svg';
import icon_chartset_delete_disabled from 'imgs/icons/windows/icon_chartset_delete_disabled.svg';
import icon_chartset_delete_hover from 'imgs/icons/windows/icon_chartset_delete_hover.svg';
import icon_chart_explorer_navbar from 'imgs/icons/windows/icon_chart_explorer_navbar.svg';
import icon_chart_explorer_navbar_selected from 'imgs/icons/windows/icon_chart_explorer_navbar_selected.svg';
import icon_recently_viewed from 'imgs/icons/windows/icon_recently_viewed.svg';
import icon_recently_viewed_hover from 'imgs/icons/windows/icon_recently_viewed_hover.svg';
import icon_device_type_placeholder from 'imgs/icons/windows/icon_device_type_placeholder.svg';
import icon_service_disabled from 'imgs/icons/windows/icon_service_disabled.svg';
import icon_delete_button_default from 'imgs/icons/windows/icon_delete_button_default.svg';
import icon_delete_button_disabled from 'imgs/icons/windows/icon_delete_button_disabled.svg';
import icon_delete_button_hover from 'imgs/icons/windows/icon_delete_button_hover.svg';

export const IconLoader = {
  blue_unlocked: blue_unlocked,
  /**
   * @deprecated use {@link WiFiOffIcon}
   */
  wifi_off: wifi_off,
  /**
   * @deprecated use {@link WiFiOnIcon}
   */
  wifi_on: wifi_on,
  warning_circle: warning_circle,
  success_check: success_check,
  red_lock: red_lock,
  led_green: led_green,
  led_gray: led_gray,
  blue_spinner: blue_spinner,
  red_spinner: red_spinner,
  led_status_gray: led_status_gray,
  led_status_green: led_status_green,
  led_status_red: led_status_red,
  icon_led_blink_on: icon_led_blink_on,
  icon_arrow_map_pop_up: icon_arrow,
  icon_geofencing: icon_geofencing,
  icon_gnb_on: icon_gnb_on,
  icon_gnb_on_hover: icon_gnb_on_hover,
  icon_gnb_off: icon_gnb_off,
  icon_gnb_off_hover: icon_gnb_off_hover,
  icon_arrows: icon_arrows,
  icon_arrows_hover: icon_arrows_hover,
  icon_action_check: icon_action_check,
  icon_search_small: icon_search_small,
  icon_polygon_creation: icon_polygon_creation,
  icon_polygon_creation_hover: icon_polygon_creation_hover,
  icon_rectangle_creation: icon_rectangle_creation,
  icon_rectangle_creation_hover: icon_rectangle_creation_hover,
  icon_dots_vertical: icon_dots_vertical,
  icon_map_expand: icon_map_expand,
  icon_map_expand_hover: icon_map_expand_hover,
  icon_map_shrink: icon_map_shrink,
  icon_map_shrink_hover: icon_map_shrink_hover,
  icon_med_close: icon_med_close,
  icon_med_close_hover: icon_med_close_hover,
  /**
   * @deprecated use {@link MoreIcon}
   */
  icon_threeV: icon_threeV,
  /**
   * @deprecated use {@link MoreIcon}
   */
  icon_threeV_hover: icon_threeV_hover,
  icon_commission: icon_commission,
  icon_commission_hover: icon_commission_hover,
  icon_commission_disabled: icon_commission_disabled,
  icon_pivot_large: icon_pivot_large,
  icon_field_enter: icon_field_enter,
  icon_field_enter_hover: icon_field_enter_hover,
  icon_entered_success: icon_entered_success,
  icon_entered_failed: icon_entered_failed,
  icon_schedule_bttn: icon_schedule_bttn,
  icon_success_SWdownload: icon_success_SWdownload,
  icon_expandunits: icon_expandunits,
  icon_expandunits_hover: icon_expandunits_hover,
  icon_collapseunits: icon_collapseunits,
  icon_collapseunits_hover: icon_collapseunits_hover,
  icon_search_blue: icon_search_blue,
  icon_search_blue_hover: icon_search_blue_hover,
  icon_view_list: icon_view_list,
  icon_view_list_hover: icon_view_list_hover,
  icon_view_list_on: icon_view_list_on,
  icon_view_comp: icon_view_comp,
  icon_view_comp_hover: icon_view_comp_hover,
  icon_view_comp_on: icon_view_comp_on,
  icon_view_map: icon_view_map,
  icon_view_map_hover: icon_view_map_hover,
  icon_view_map_on: icon_view_map_on,
  icon_moreinfo: icon_moreinfo,
  icon_moreinfo_hover: icon_moreinfo_hover,
  icon_moreinfo_exp: icon_moreinfo_exp,
  icon_moreinfo_exp_hover: icon_moreinfo_exp_hover,
  /**
   * @deprecated use {@link ChevronUpIcon} and {@link ChevronDownIcon}
   */
  icon_table_sort: icon_table_sort,
  /**
   * @deprecated use {@link ChevronUpIcon} and {@link ChevronDownIcon}
   */
  icon_table_sort_hover: icon_table_sort_hover,
  icon_toggle_name: icon_toggle_name,
  icon_toggle_name_hover: icon_toggle_name_hover,
  icon_toggle_id: icon_toggle_id,
  icon_toggle_id_hover: icon_toggle_id_hover,
  /**
   * @deprecated use {@link CloseIcon}
   */
  icon_close_x: icon_close_x,
  /**
   * @deprecated use {@link CloseIcon}
   */
  icon_close_x_hover: icon_close_x_hover,
  icon_customdate: icon_customdate,
  icon_add: icon_add,
  icon_add_hover: icon_add_hover,
  /**
   * @deprecated use {@link ExportIcon}
   */
  icon_export: icon_export,
  /**
   * @deprecated use {@link ExportIcon}
   */
  icon_export_hover: icon_export_hover,
  icon_spinner_small: icon_spinner_small,
  /**
   * @deprecated use {@link MoreIcon}
   */
  icon_more_H: icon_more_H,
  /**
   * @deprecated use {@link MoreIcon}
   */
  icon_more_H_hover: icon_more_H_hover,
  icon_edit: icon_edit,
  icon_edit_hover: icon_edit_hover,
  icon_checkbox_checked: icon_checkbox_checked,
  icon_checkbox_unchecked: icon_checkbox_unchecked,
  icon_checkbox_checked_hover: icon_checkbox_checked_hover,
  icon_clear_flter_x: icon_clear_flter_x,
  icon_clear_flter_x_hover: icon_clear_flter_x_hover,
  icon_more_note: icon_more_note,
  icon_more_note_hover: icon_more_note_hover,
  icon_device_more: icon_device_more,
  icon_device_more_hover: icon_device_more_hover,
  icon_device_note: icon_device_note,
  icon_device_note_hover: icon_device_note_hover,
  icon_device_close: icon_device_close,
  icon_device_close_hover: icon_device_close_hover,
  icon_help_xs: icon_help_xs,
  icon_help_xs_hover: icon_help_xs_hover,
  icon_action: icon_action,
  icon_action_hover: icon_action_hover,
  icon_select_all: icon_select_all,
  icon_select_all_hover: icon_select_all_hover,
  icon_select_none: icon_select_none,
  icon_select_none_hover: icon_select_none_hover,
  icon_select_poli: icon_select_poli,
  icon_select_poli_hover: icon_select_poli_hover,
  icon_select_circle: icon_select_circle,
  icon_select_circle_hover: icon_select_circle_hover,
  icon_select_rec: icon_select_rec,
  icon_select_rec_hover: icon_select_rec_hover,
  /**
   * @deprecated use {@link ZoomInIcon}
   */
  icon_zoomin: icon_zoomin,
  /**
   * @deprecated use {@link ZoomInIcon}
   */
  icon_zoomin_hover: icon_zoomin_hover,
  /**
   * @deprecated use {@link ZoomOutIcon}
   */
  icon_zoomout: icon_zoomout,
  /**
   * @deprecated use {@link ZoomOutIcon}
   */
  icon_zoomout_hover: icon_zoomout_hover,
  /**
   * @deprecated use {@link ZoomInIcon}
   */
  icon_zoom_in: icon_zoom_in,
  /**
   * @deprecated use {@link ZoomInIcon}
   */
  icon_zoom_in_hover: icon_zoom_in_hover,
  /**
   * @deprecated use {@link ZoomOutIcon}
   */
  icon_zoom_out: icon_zoom_out,
  /**
   * @deprecated use {@link ZoomOutIcon}
   */
  icon_zoom_out_hover: icon_zoom_out_hover,
  icon_donor: icon_donor,
  icon_service: icon_service,
  icon_reboot_success: icon_reboot_success,
  icon_close_circle: icon_close_circle,
  icon_close_circle_hover: icon_close_circle_hover,
  icon_unlocked: icon_unlocked,
  icon_unlocked_disabled: icon_unlocked_disabled,
  icon_locked: icon_locked,
  icon_locked_disabled: icon_locked_disabled,
  icon_unlocking: icon_unlocking,
  icon_locking: icon_locking,
  icon_wifi_disabled: icon_wifi_disabled,
  icon_wifi_disabling: icon_wifi_disabling,
  icon_wifi_enabled: icon_wifi_enabled,
  icon_wifi_enabling: icon_wifi_enabling,
  icon_close_mid: icon_close_mid,
  icon_close_mid_hover: icon_close_mid_hover,
  icon_error_mid: icon_error_mid,
  icon_wifi_showAPN: icon_wifi_showAPN,
  icon_wifi_showAPN_hover: icon_wifi_showAPN_hover,
  icon_add_time: icon_add_time,
  icon_add_time_hover: icon_add_time_hover,
  icon_subtract_time: icon_subtract_time,
  icon_sandclock: icon_sandclock,
  icon_subtract_time_hover: icon_subtract_time_hover,
  icon_failed_medium: icon_failed_medium,
  /**
   * @deprecated use {@link CheckIcon}, example at {@link PreferenceNameEditor}
   */
  icon_commit_edit: icon_commit_edit,
  /**
   * @deprecated use {@link CloseIcon}, example at {@link PreferenceNameEditor}
   */
  icon_cancel_edit: icon_cancel_edit,
  /**
   * @deprecated use {@link CheckIcon}, example at {@link PreferenceNameEditor}
   */
  icon_commit_disabled: icon_commit_disabled,
  /**
   * @deprecated use {@link EditIcon}, example at {@link ChartSetPreferenceListItem}
   */
  icon_edit_name: icon_edit_name,
  /**
   * @deprecated use {@link EditIcon}, example at {@link ChartSetPreferenceListItem}
   */
  icon_edit_name_hover: icon_edit_name_hover,
  icon_collapse_row: icon_collapse_row,
  icon_collapse_row_hover: icon_collapse_row_hover,
  icon_x: icon_x,
  icon_x_hover: icon_x_hover,
  icon_scheduling: icon_scheduling,
  icon_success: icon_success,
  icon_error: icon_error,
  icon_init: icon_init,
  icon_rebooting: icon_rebooting,
  icon_note: icon_note,
  icon_note_hover: icon_note_hover,
  icon_dropdown_arrow: icon_dropdown_arrow,
  icon_dropdown_arrow_hover: icon_dropdown_arrow_hover,
  icon_logo_IBMS_compact_fixed: icon_logo_IBMS_compact_fixed,
  icon_IBMS_wide: icon_IBMS_wide,
  icon_devices: icon_devices,
  icon_devices_hover: icon_devices_hover,
  icon_actions: icon_actions,
  icon_actions_hover: icon_actions_hover,
  icon_admin: icon_admin,
  icon_admin_hover: icon_admin_hover,
  /**
   * @deprecated use {@link UserIcon}
   */
  icon_user: icon_user,
  /**
   * @deprecated use {@link UserIcon}
   */
  icon_user_hover: icon_user_hover,
  icon_expand: icon_expand,
  icon_expand_hover: icon_expand_hover,
  icon_rastering: icon_rastering,
  icon_close_errorbox: icon_close_errorbox,
  icon_close_errorbox_hover: icon_close_errorbox_hover,
  icon_raster_success: icon_raster_success,
  icon_search: icon_search,
  icon_error_s: icon_error_s,
  icon_schedule_bttn_hover: icon_schedule_bttn_hover,
  icon_revert: icon_revert,
  icon_revert_hover: icon_revert_hover,
  icon_slider_bg: icon_slider_bg,
  icon_check_green: icon_check_green,
  icon_uploadnewversion: icon_uploadnewversion,
  icon_delete: icon_delete,
  icon_delete_hover: icon_delete_hover,
  icon_logo: icon_logo,
  icon_ibms_wide_white: icon_ibms_wide_white,
  icon_login_mail: icon_login_mail,
  icon_login_mail_on: icon_login_mail_on,
  icon_login_mail_error: icon_login_mail_error,
  icon_login_password: icon_login_password,
  icon_login_password_on: icon_login_password_on,
  icon_login_password_error: icon_login_password_error,
  /**
   * @deprecated use {@link InfoIcon}
   */
  icon_info: icon_info,
  /**
   * @deprecated use {@link InfoIcon}
   */
  icon_info_hover: icon_info_hover,
  icon_info_small: icon_info_small,
  icon_info_small_hover: icon_info_small_hover,
  icons_arrow_goback: icons_arrow_goback,
  icons_arrow_goback_hover: icons_arrow_goback_hover,
  icon_alarm_undefined: icon_alarm_undefined,
  icon_alarm_critical: icon_alarm_critical,
  icon_alarm_major: icon_alarm_major,
  icon_alarm_minor: icon_alarm_minor,
  icon_alarm_warning: icon_alarm_warning,
  icon_alarm_info: icon_alarm_info,
  icon_vertical_expand: icon_vertical_expand,
  icon_vertical_expand_hover: icon_vertical_expand_hover,
  icon_browser_chrome: icon_browser_chrome,
  icon_browser_firefox: icon_browser_firefox,
  icon_browser_edge: icon_browser_edge,
  icon_view_alarm: icon_view_alarm,
  icon_view_alarm_hover: icon_view_alarm_hover,
  icon_alarm_noalarm: icon_alarm_noalarm,
  icon_LED_turning: icon_LED_turning,
  icon_error_white: icon_error_white,
  icon_log: icon_log,
  icon_log_hover: icon_log_hover,
  icon_historical_log: icon_historical_log,
  icon_historical_log_hover: icon_historical_log_hover,
  icon_log_pause: icon_log_pause,
  icon_log_start: icon_log_start,
  icon_log_expand_rows: icon_log_expand_rows,
  icon_log_expand_rows_hover: icon_log_expand_rows_hover,
  icon_log_expand_cell: icon_log_expand_cell,
  icon_log_expand_cell_hover: icon_log_expand_cell_hover,
  icon_config_table: icon_config_table,
  icon_config_table_hover: icon_config_table_hover,
  icon_config_table_on: icon_config_table_on,
  icon_config_table_charts: icon_config_table_charts,
  icon_config_table_charts_hover: icon_config_table_charts_hover,
  icon_config_table_charts_on: icon_config_table_charts_on,
  icon_config_charts: icon_config_charts,
  icon_config_charts_hover: icon_config_charts_hover,
  icon_config_charts_on: icon_config_charts_on,
  icon_arrow_open_options: icon_arrow_open_options,
  icon_arrow_open_options_hover: icon_arrow_open_options_hover,
  icon_arrow_closed_options: icon_arrow_closed_options,
  icon_arrow_closed_options_hover: icon_arrow_closed_options_hover,
  icon_log_export: icon_log_export,
  icon_log_export_hover: icon_log_export_hover,
  icon_calendar: icon_calendar,
  icon_roles_add: icon_roles_add,
  icon_roles_add_hover: icon_roles_add_hover,
  icon_three_more: icon_three_more,
  icon_three_more_hover: icon_three_more_hover,
  icon_userpage_edit: icon_userpage_edit,
  icon_userpage_edit_hover: icon_userpage_edit_hover,
  icon_role_none_selected: icon_role_none_selected,
  icon_role_select_hover: icon_role_select_hover,
  icon_role_selected: icon_role_selected,
  icon_edit_detail: icon_edit_detail,
  icon_edit_detail_hover: icon_edit_detail_hover,
  icon_alarm_critical_num: icon_alarm_critical_num,
  icon_alarm_warning_num: icon_alarm_warning_num,
  icon_alarm_major_num: icon_alarm_major_num,
  icon_alarm_info_num: icon_alarm_info_num,
  icon_alarm_minor_num: icon_alarm_minor_num,
  icon_alarm_unknown_num: icon_alarm_unknown_num,
  icon_alarm_major_minor_none: icon_alarm_major_minor_none,
  icon_alarm_unknown_none: icon_alarm_unknown_none,
  icon_alarm_critical_none: icon_alarm_critical_none,
  icon_alarm_warning_info_none: icon_alarm_warning_info_none,
  icon_highlight: icon_highlight,
  icon_highlight_hover: icon_highlight_hover,
  icon_not_commissioned_off: icon_not_commissioned_off,
  icon_not_commissioned: icon_not_commissioned,
  icon_commissioned: icon_commissioned,
  icon_commissioned_gray: icon_commissioned_gray,
  icon_offline_off: icon_offline_off,
  icon_offline: icon_offline,
  icon_connected: icon_connected,
  icon_locked_off: icon_locked_off,
  icon_locked_device: icon_locked_device,
  icon_locked_device_off: icon_locked_device_off,
  icon_handle: icon_handle,
  icon_handle_hover_drag: icon_handle_hover_drag,
  icon_close_window_mid: icon_close_window_mid,
  icon_close_window_mid_hover: icon_close_window_mid_hover,
  icon_echo: icon_echo,
  icon_pivot: icon_pivot,
  icon_main_grid: icon_main_grid,
  icon_main_grid_hover: icon_main_grid_hover,
  icon_main_grid_on: icon_main_grid_on,
  icon_main_split: icon_main_split,
  icon_main_split_hover: icon_main_split_hover,
  icon_main_split_on: icon_main_split_on,
  icon_main_table: icon_main_table,
  icon_main_table_hover: icon_main_table_hover,
  icon_main_table_on: icon_main_table_on,
  icon_sort: icon_sort,
  icon_sort_hover: icon_sort_hover,
  icon_warning: icon_warning,
  icon_warning_2: icon_warning_2,
  icon_window_preferences: icon_window_preferences,
  icon_window_preferences_hover: icon_window_preferences_hover,
  /**
   * @deprecated use {@link AddCircleIcon}
   */
  icon_save_set: icon_save_set,
  icon_add_devices: icon_add_devices,
  icon_create_plus: icon_create_plus,
  icon_actions_pill: icon_actions_pill,
  icon_close_white: icon_close_white,
  icon_close_white_hover: icon_close_white_hover,
  /**
   * @deprecated use {@link SettingsIcon}
   */
  icon_manage_set: icon_manage_set,
  /**
   * @deprecated use {@link ToggleButton}
   */
  bttn_make_default: bttn_make_default,
  /**
   * @deprecated use {@link ToggleButton}
   */
  bttn_make_default_hover: bttn_make_default_hover,
  /**
   * @deprecated use {@link ToggleButton}
   */
  bttn_make_default_select: bttn_make_default_select,
  icon_delete_list: icon_delete_list,
  icon_delete_list_hover: icon_delete_list_hover,
  icon_back_doc: icon_back_doc,
  icon_back_doc_hover: icon_back_doc_hover,
  /**
   * @deprecated use {@link UpdateButton}
   */
  bttn_update_filterset_hover: bttn_update_filterset_hover,
  /**
   * @deprecated use {@link UpdateButton}
   */
  bttn_update_filterset_on: bttn_update_filterset_on,
  /**
   * @deprecated use {@link UpdateButton}
   */
  bttn_update_filterset_off: bttn_update_filterset_off,
  icons_cross_small: icons_cross_small,
  icons_cross_small_hover: icons_cross_small_hover,
  icon_add_16: icon_add_16,
  icon_add_16_hover: icon_add_16_hover,
  icon_upload_18: icon_upload_18,
  icon_upload_18_hover: icon_upload_18_hover,
  icon_warning_round: icon_warning_round,
  left_arrow_default: left_arrow_default,
  left_arrow_hover: left_arrow_hover,
  icon_commission_success: icon_commission_success,
  icon_beamrank_1: icon_beamrank_1,
  icon_beamrank_2: icon_beamrank_2,
  icon_beamrank_3: icon_beamrank_3,
  icon_beamrank_c: icon_beamrank_c,
  icon_beamrank_1_selected: icon_beamrank_1_selected,
  icon_beamrank_2_selected: icon_beamrank_2_selected,
  icon_beamrank_3_selected: icon_beamrank_3_selected,
  icon_beamrank_c_selected: icon_beamrank_c_selected,
  icon_dropdown_arrow_24_default: icon_dropdown_arrow_24_default,
  icon_dropdown_arrow_24_hover: icon_dropdown_arrow_24_hover,
  /**
   * @deprecated use Switch
   */
  icon_toggle_40_hover: icon_toggle_40_hover,
  /**
   * @deprecated use Switch
   */
  icon_toggle_40_off: icon_toggle_40_off,
  /**
   * @deprecated use Switch
   */
  icon_toggle_40_on: icon_toggle_40_on,
  icon_setup_24_hover: icon_setup_24_hover,
  icon_setup_24_default: icon_setup_24_default,
  icon_confighistory: icon_confighistory,
  icon_confighistory_hover: icon_confighistory_hover,
  /**
   * @deprecated use {@link ReceiveIcon}
   */
  icon_retrieve_default: icon_retrieve_default,
  /**
   * @deprecated use {@link ReceiveIcon}
   */
  icon_retrieve_hover: icon_retrieve_hover,
  /**
   * @deprecated use {@link ReceiveIcon}
   */
  icon_retrieve_disabled: icon_retrieve_disabled,
  icon_split_default: icon_split_default,
  icon_split_hover: icon_split_hover,
  icon_split_selected: icon_split_selected,
  icon_checked_with_permission: icon_all,
  icon_checked_without_permission: icon_all_mute,
  icon_partially_checked_with_permission: icon_partial,
  icon_partially_checked_without_permission: icon_partial_mute,
  icon_unchecked_with_permission: icon_none,
  icon_unchecked_without_permission: icon_none_mute,
  icon_bluecheckbox_checked: icon_bluecheckbox_checked,
  icon_bluecheckbox_unchecked: icon_bluecheckbox_unchecked,
  icon_bluecheckbox_hover: icon_bluecheckbox_hover,
  icon_greycheckbox: icon_greycheckbox,
  icon_triangle: icon_triangle,
  icon_checkbox_unchecked_disabled: icon_checkbox_unchecked_disabled,
  icon_checkbox_checked_disabled: icon_checkbox_checked_disabled,
  icon_import: icon_import,
  icon_import_hover: icon_import_hover,
  icon_diag_raster: icon_diag_raster,
  icon_diag_raster_hovered: icon_diag_raster_hovered,
  icon_monitor: icon_monitor,
  icon_monitor_hover: icon_monitor_hover,
  icon_monitor_selected: icon_monitor_selected,
  /**
   * @deprecated use Switch
   */
  icon_toggle_on: icon_toggle_on,
  /**
   * @deprecated use Switch
   */
  icon_toggle_on_hover: icon_toggle_on_hover,
  /**
   * @deprecated use Switch
   */
  icon_toggle_off: icon_toggle_off,
  /**
   * @deprecated use Switch
   */
  icon_toggle_off_hover: icon_toggle_off_hover,
  icon_create_new: icon_create_new,
  icon_create_new_hover: icon_create_new_hover,
  icon_alert_show_less: icon_alert_show_less,
  icon_alert_show_less_hover: icon_alert_show_less_hover,
  icon_alert_show_more: icon_alert_show_more,
  icon_alert_show_more_hover: icon_alert_show_more_hover,
  icon_duplicate: icon_duplicate,
  icon_duplicate_hover: icon_duplicate_hover,
  icon_editing: icon_editing,
  icon_editing_hover: icon_editing_hover,
  /**
   * @deprecated use {@link TrashIcon}
   */
  icon_trash: icon_trash,
  /**
   * @deprecated use {@link TrashIcon}
   */
  icon_trash_hover: icon_trash_hover,
  icon_orange_checkbox_checked_disabled: icon_orange_checkbox_checked_disabled,
  icon_orange_checkbox_not_checked_disabled: icon_orange_checkbox_not_checked_disabled,
  icon_primary_checkbox_checked: icon_primary_checkbox_checked,
  icon_primary_checkbox_not_checked: icon_primary_checkbox_not_checked,
  icon_primary_checkbox_not_checked_hover: icon_primary_checkbox_not_checked_hover,
  icon_multy_value_close: icon_multy_value_close,
  icon_multy_value_close_hover: icon_multy_value_close_hover,
  icon_reveal_devices: icon_reveal_devices,
  icon_reveal_devices_hover: icon_reveal_devices_hover,
  icon_reveal_devices_disabled: icon_reveal_devices_disabled,
  icon_hide_devices: icon_hide_devices,
  icon_hide_devices_disabled: icon_hide_devices_disabled,
  icon_hide_devices_hover: icon_hide_devices_hover,
  icon_polygons_pivots_search: icon_polygons_pivots_search,
  icon_device_donor: icon_device_donor,
  icon_device_service: icon_device_service,
  icon_device_donor_small: icon_device_donor_small,
  icon_device_donor_grey_small: icon_device_donor_grey_small,
  icon_device_service_small: icon_device_service_small,
  icon_device_service_grey_small: icon_device_service_grey_small,
  icon_pivot_circle: icon_pivot_circle,
  icon_polygon_circle: icon_polygon_circle,
  icon_section_close: icon_section_close,
  icon_section_close_hover: icon_section_close_hover,
  icon_section_close_disabled: icon_section_close_disabled,
  icon_export_tool: icon_export_tool,
  icon_export_tool_hover: icon_export_tool_hover,
  icon_import_tool: icon_import_tool,
  icon_import_tool_hover: icon_import_tool_hover,
  icon_alerts_history: icon_alerts_history,
  icon_alerts_history_hover: icon_alerts_history_hover,
  icon_alerts_goback: icon_alerts_goback,
  icon_alerts_goback_hover: icon_alerts_goback_hover,
  icon_more_and_equal_operator: icon_more_and_equal_operator,
  icon_more_operator: icon_more_operator,
  icon_equal_operator: icon_equal_operator,
  icon_not_equal_operator: icon_not_equal_operator,
  icon_less_operator: icon_less_operator,
  icon_less_or_equal_operator: icon_less_or_equal_operator,
  icon_diag_raster_disabled: icon_diag_raster_disabled,
  right_arrow: right_arrow,
  swapper: swapper,
  swapper_hover: swapper_hover,
  warning_orange: warning_orange,
  icon_black_right_arrow: icon_black_right_arrow,
  icon_drag_dots_default: icon_drag_dots_default,
  icon_drag_dots_hover: icon_drag_dots_hover,
  locked_hover: locked_hover,
  locked_default: locked_default,
  icon_unlocked_default: icon_unlocked_default,
  unlocked_hover: unlocked_hover,
  unlocked_default: unlocked_default,
  locked_reversed: locked_reversed,
  icon_locked_status: icon_locked_status,
  icon_locked_status_hover: icon_locked_status_hover,
  icon_unlocked_status: icon_unlocked_status,
  icon_unlocked_status_hover: icon_unlocked_status_hover,
  /**
   * @deprecated use {@link WiFiOnIcon}
   */
  icon_wifi_on_status: icon_wifi_on_status,
  /**
   * @deprecated use {@link WiFiOnIcon}
   */
  icon_wifi_on_status_hover: icon_wifi_on_status_hover,
  /**
   * @deprecated use {@link WiFiOffIcon}
   */
  icon_wifi_off_status: icon_wifi_off_status,
  /**
   * @deprecated use {@link WiFiOffIcon}
   */
  icon_wifi_off_status_hover: icon_wifi_off_status_hover,
  icon_pivot_header: icon_pivot_header,
  /**
   * @deprecated use {@link DownloadIcon}
   */
  icon_file_download: icon_file_download,
  /**
   * @deprecated use {@link DownloadIcon}
   */
  icon_file_download_hover: icon_file_download_hover,
  /**
   * @deprecated use {@link TrashIcon}, example at {@link ChartSetPreferenceListItem}
   */
  icon_chartset_delete: icon_chartset_delete,
  /**
   * @deprecated use {@link TrashIcon}, example at {@link ChartSetPreferenceListItem}
   */
  icon_chartset_delete_disabled: icon_chartset_delete_disabled,
  /**
   * @deprecated use {@link TrashIcon}, example at {@link ChartSetPreferenceListItem}
   */
  icon_chartset_delete_hover: icon_chartset_delete_hover,
  /**
   * @deprecated use {@link ExploreIcon}
   */
  icon_chart_explorer_navbar: icon_chart_explorer_navbar,
  /**
   * @deprecated use {@link ExploreIcon}
   */
  icon_chart_explorer_navbar_selected: icon_chart_explorer_navbar_selected,
  icon_recently_viewed: icon_recently_viewed,
  icon_recently_viewed_hover: icon_recently_viewed_hover,
  icon_device_type_placeholder: icon_device_type_placeholder,
  icon_service_disabled: icon_service_disabled,
  icon_delete_button_default: icon_delete_button_default,
  icon_delete_button_disabled: icon_delete_button_disabled,
  icon_delete_button_hover: icon_delete_button_hover,
};
